import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const BASE = `${API_URL}/api/outreach`;

const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('outreach_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('outreach_token');
      window.location.href = '/outreach/login';
    }
    return Promise.reject(err);
  }
);

export const authApi = {
  sendOtp: (email) => api.post('/auth/send-otp', { email }).then(r => r.data),
  verifyOtp: (email, otp) => api.post('/auth/verify-otp', { email, otp }).then(r => r.data),
  me: () => api.get('/auth/me').then(r => r.data),
};

// Folders
export const foldersApi = {
  getAll: () => api.get('/folders').then(r => r.data),
  create: (name) => api.post('/folders', { name }).then(r => r.data),
  rename: (id, name) => api.put(`/folders/${id}`, { name }).then(r => r.data),
  delete: (id) => api.delete(`/folders/${id}`).then(r => r.data),
  uploadLeads: (folderId, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post(`/folders/${folderId}/upload`, fd).then(r => r.data);
  },
  addLead: (folderId, lead) => api.post(`/folders/${folderId}/leads`, lead).then(r => r.data),
};

// Leads
export const leadsApi = {
  getAll: (params) => api.get('/leads', { params }).then(r => r.data),
  delete: (id) => api.delete(`/leads/${id}`).then(r => r.data),
  tag: (id, tag) => api.put(`/leads/${id}/tag`, { tag }).then(r => r.data),
  upload: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/leads/upload', fd).then(r => r.data);
  },
  verify: (folderId) => api.post('/leads/verify', null, { params: folderId ? { folder_id: folderId } : {} }).then(r => r.data),
  enrich: (folderId) => api.post('/leads/enrich', null, { params: folderId ? { folder_id: folderId } : {} }).then(r => r.data),
  verifySingle: (id) => api.post(`/leads/${id}/verify`).then(r => r.data),
  enrichSingle: (id) => api.post(`/leads/${id}/enrich`).then(r => r.data),
  jobStatus: (jobId) => api.get(`/leads/job/${jobId}`).then(r => r.data),
};

// Campaigns
export const campaignsApi = {
  getAll: () => api.get('/campaigns').then(r => r.data),
  get: (id) => api.get(`/campaigns/${id}`).then(r => r.data),
  create: (data) => api.post('/campaigns', data).then(r => r.data),
  launch: (id) => api.put(`/campaigns/${id}/launch`).then(r => r.data),
  pause: (id) => api.put(`/campaigns/${id}/pause`).then(r => r.data),
  resume: (id) => api.put(`/campaigns/${id}/resume`).then(r => r.data),
  stop: (id) => api.put(`/campaigns/${id}/stop`).then(r => r.data),
  delete: (id) => api.delete(`/campaigns/${id}`).then(r => r.data),
  duplicate: (id) => api.post(`/campaigns/${id}/duplicate`).then(r => r.data),
  getLeads: (id, params) => api.get(`/campaigns/${id}/leads`, { params }).then(r => r.data),
  getActivity: (id, limit) => api.get(`/campaigns/${id}/activity?limit=${limit || 100}`).then(r => r.data),
  export: (id) => api.get(`/campaigns/${id}/export`).then(r => r.data),
};

// Settings
export const settingsApi = {
  get: () => api.get('/settings').then(r => r.data),
  update: (data) => api.put('/settings', data).then(r => r.data),
};

// Email Accounts
export const emailAccountsApi = {
  getAll: () => api.get('/email-accounts').then(r => r.data),
  add: (data) => api.post('/email-accounts', data).then(r => r.data),
  update: (id, data) => api.put(`/email-accounts/${id}`, data).then(r => r.data),
  delete: (id) => api.delete(`/email-accounts/${id}`).then(r => r.data),
  test: (id) => api.post(`/email-accounts/${id}/test`).then(r => r.data),
  health: (id) => api.get(`/email-accounts/${id}/health`).then(r => r.data),
};

// Blacklist
export const blacklistApi = {
  getAll: (params) => api.get('/blacklist', { params }).then(r => r.data),
  add: (value) => api.post('/blacklist', { value }).then(r => r.data),
  remove: (id) => api.delete(`/blacklist/${id}`).then(r => r.data),
  import: (items) => api.post('/blacklist/import', { items }).then(r => r.data),
};

// Analytics
export const analyticsApi = {
  dashboard: () => api.get('/analytics/dashboard').then(r => r.data),
};

// Inbox
export const inboxApi = {
  getAll: (params) => api.get('/inbox', { params }).then(r => r.data),
  get: (id) => api.get(`/inbox/${id}`).then(r => r.data),
  markRead: (id) => api.put(`/inbox/${id}/read`).then(r => r.data),
  markUnread: (id) => api.put(`/inbox/${id}/unread`).then(r => r.data),
  checkNow: () => api.post('/inbox/check-now').then(r => r.data),
  reply: (id, body) => api.post(`/inbox/${id}/reply`, { body }).then(r => r.data),
};
